<template>
  <div class="CommonContentSingle-gray Crisis_upreport">
    <el-container>
      <el-header style="background:rgba(255, 255, 255, 1);min-height:80px;height:auto;padding: 0 15px">
        <!-- <el-button type="primary" @click="jump('RCWJSB')">日常危机上报</el-button> -->
        <!-- <el-button type="primary" @click="jump('ZXSSB')">咨询师上报</el-button>
        <el-button type="primary" @click="jump('RXSB')">热线上报</el-button>
        <el-button type="primary" @click="jum2p('RXWJSB')">热销上报</el-button> -->
        <el-form :model="ruleForm" ref="ruleForm" :inline="true" class="demo-form-inline" style="margin: 0px 0px;background:rgba(255, 255, 255, 1);padding: 10px; ">
          <el-form-item label="综合查询">
            <el-input placeholder="账号/学号/身份证号/姓名" v-model="ruleForm.Name"></el-input>
          </el-form-item>
          <el-form-item label="部门">
            <el-cascader ref="wcascader" @change="Selected_to_shut_dow" @expand-change="bumen" v-model="DeptID"
              filterable :options="optionsnew" :props="{ checkStrictly: true }" clearable :placeholder = ruleForm.ts></el-cascader>
          </el-form-item>
          <el-form-item label="年级">
            <el-select v-model="ruleForm.EntryDate" placeholder="请选择年级">
              <el-option v-for="item in gradedata" :key="item.dicKey" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="学位">
            <el-select v-model="ruleForm.Degree" placeholder="请选择学位">
              <el-option label="本科生" value="本科生"></el-option>
              <el-option label="硕士研究生" value="硕士研究生"></el-option>
              <el-option label="博士研究生" value="博士研究生"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="上报类型">
            <el-select v-model="ruleForm.Type" placeholder="请选择上报类型">
              <el-option label="日常危机上报" value="日常危机上报"></el-option>
              <el-option label="测评访谈" value="测评访谈"></el-option>
              <el-option label="自主上报" value="自主上报"></el-option>
              <el-option label="咨询上报" value="咨询上报"></el-option>
              <el-option label="热线上报" value="热线上报"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="上报状态">
            <el-select v-model="ruleForm.ReportStatus" placeholder="请选择上报状态">
              <el-option label="待建立重点台账" value="1"></el-option>
              <el-option label="待风险监控员初审" value="2"></el-option>
              <el-option label="无法确定" value="3"></el-option>
              <el-option label="无需干预" value="4"></el-option>
              <el-option label="待危机主管复核" value="5"></el-option>
              <el-option label="待中心主任审核" value="6"></el-option>
              <el-option label="待上报" value="7"></el-option>
              <el-option label="已上报" value="8"></el-option>
              <el-option label="未提交" value="9"></el-option>
              <el-option label="风险监控员审核驳回" value="10"></el-option>
              <el-option label="危机主管审核驳回" value="11"></el-option>
              <el-option label="中心主任审核驳回" value="12"></el-option>
              <el-option label="待咨询师评估" value="16"></el-option>
              <el-option label="待咨询主管审核" value="17"></el-option>
              <el-option label="咨询主管驳回" value="18"></el-option>
              <el-option label="待热线管理员审核" value="19"></el-option>
              <el-option label="热线管理员驳回" value="20"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="办理状态">
            <el-select v-model="ruleForm.FeedBackState" placeholder="请选择办理状态">
              <el-option label="已驳回" value="1"></el-option>
              <el-option label="待复核" value="2"></el-option>
              <el-option label="待危机主管办理" value="3"></el-option>
              <el-option label="待风险监控员办理" value="4"></el-option>
              <el-option label="已办理" value="5"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="危机状态">
            <el-select v-model="ruleForm.UrgentStatus" placeholder="请选择上报类型">
              <el-option label="--" value="0"></el-option>
              <el-option label="红色预警" value="1"></el-option>
              <el-option label="橙色预警" value="2"></el-option>
              <el-option label="黄色预警" value="3"></el-option>
              <el-option label="蓝色预警" value="4"></el-option>
              <el-option label="绿色预警" value="5"></el-option>
              <el-option label="无法确定" value="6"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开始时间">
            <el-date-picker v-model="StartTime" type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间">
            <el-date-picker v-model="EndTime" type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
          </el-form-item>
          <el-button type="primary" @click="onSelect()">查询</el-button>
          <el-button type="primary" @click="resetForm()" style="margin-top: 5px;margin-left:10px">重置</el-button>
          <!-- <el-button v-if="pdroleid(1063) || pdroleid(1089)" type="primary" @click="addfun()" style="margin-top: 5px;margin-left:10px">新建台账</el-button>
          <el-button v-if=" pdroleid(1086)" type="primary" @click="ClickHotwire()" style="margin-top: 5px;margin-left:10px">热线上报</el-button> -->
        </el-form>
      </el-header>

      <!-- <el-button @click="xaxaii()" type="primary">主要按钮</el-button> -->

      <div style="height:100%;background-color: #fff;margin-top: 20px;">
        <p style="width: 98%;margin-left:1%;height: 36px;line-height:36px;background:rgba(250, 220, 220, 1);margin-top:15px"> <span style="color: rgba(201, 28, 28, 1);margin-left:20px">初审：{{keyLedgerOverallStatistics.theFirstTrial}}</span> <span style="color: rgba(201, 28, 28, 1);margin-left:20px">主管审核：{{keyLedgerOverallStatistics.supervisorReview}}</span> <span style="color: rgba(201, 28, 28, 1);margin-left:20px">待上报：{{keyLedgerOverallStatistics.toBeReported}}</span> <span style="color: rgba(201, 28, 28, 1);margin-left:20px">已上报：{{keyLedgerOverallStatistics.reported}}</span></p>


        <el-table :data="tableData" stripe style="width: 98%;margin-left:1%;margin-top:15px" v-loading="loading" @sort-change="changeReporttime">
          <el-table-column label="序号" width="60px" align="left">
            <template slot-scope="scope" center>
              {{ (pageIndexs - 1) * 10 + scope.$index + 1 }}
            </template>
          </el-table-column>

          <el-table-column label="学生学号">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.userId }}</span>
            </template>
          </el-table-column>

          <el-table-column label="姓名">
            <template slot-scope="scope">
              <span>{{ scope.row.realName }}</span>
            </template>
          </el-table-column>

          <el-table-column label="培养单位">
            <template slot-scope="scope">
              <span>{{ scope.row.deptName }}</span>
            </template>
          </el-table-column>

          <el-table-column label="上报人">
            <template slot-scope="scope">
              <span>{{ scope.row.reportId }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="reportTime" label="上报时间" sortable="custom" ></el-table-column>

          <el-table-column label="上报类型">
            <template slot-scope="scope">
              <span>{{ scope.row.type }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="urgentStatus" label="危机状态" sortable="custom">
            <template slot-scope="scope" >
              <span v-if="scope.row.urgentStatus == '黄色预警'" style="color: #A68F52;">{{ scope.row.urgentStatus }}</span>
              <span v-else-if="scope.row.urgentStatus == '橙色预警'" style="color: rgb(252, 111, 68);">{{ scope.row.urgentStatus }}</span>
              <span v-else-if="scope.row.urgentStatus == '红色预警'" style="color: #FF0808;">{{ scope.row.urgentStatus }}</span>
              <span v-else-if="scope.row.urgentStatus == '蓝色预警'" style="color: rgba(0, 136, 255, 1);">{{ scope.row.urgentStatus }}</span>
              <span v-else-if="scope.row.urgentStatus == '绿色预警'" style="color: rgb(112 191 15);">{{ scope.row.urgentStatus }}</span>
              <span v-else-if="scope.row.urgentStatus == '--'">{{ scope.row.urgentStatus }}</span>
            </template>
          </el-table-column>

          <el-table-column label="上报状态">
            <template slot-scope="scope">
              <span>{{ scope.row.reportStatus }}</span>
            </template>
          </el-table-column>
          <el-table-column label="办理状态">
            <template slot-scope="scope">
              <span>{{ getFeedBackStateText(scope.row.FeedBackState) }}</span>
            </template>
          </el-table-column>

          <el-table-column class="xsii" prop="address" label="操作">
            <template slot-scope="scope">
              
              <!-- 1059是咨询师 -->
              <div v-if="pdroleid(1059) && scope.row.type == '咨询上报'">
                <span v-if="scope.row.reportStatus == '咨询主管驳回'" style="cursor: pointer;color: rgb(31, 52, 245);" @click="$router.push('/Consultant/AppointmentList?KeyNo='+scope.row.KeyNo)">修改</span>
                <span v-if="scope.row.reportStatus == '咨询主管驳回'" style="cursor: pointer;color: rgb(31, 52, 245);" @click="Viewreject(scope.row)">查看驳回原因</span>
                <!-- <span v-if="scope.row.psychCentralSuggest!=''" style="cursor: pointer;color: rgb(31, 52, 245);" @click="looksfun(scope.row.KeyNo, scope.row.reportStatus)">查看明细</span> -->
              </div>
              
              <!-- 咨询主管 -->
              <div v-if="pdroleid(1066) && scope.row.type == '咨询上报'">
                <span v-if="scope.row.reportStatus == '待咨询主管审核' || scope.row.reportStatus =='危机主管审核驳回'" style="cursor: pointer;color: rgb(31, 52, 245);" @click="Visited(scope.row)">咨询主管初审</span>
                <span v-else-if="scope.row.type == '咨询上报' && scope.row.reportStatus != '待咨询主管审核'" style="cursor: pointer;color: rgb(31, 52, 245);" @click="ViewRecords(scope.row)">查看上报记录</span>
              </div>

              <div v-else-if="pdroleid(1066)">
                <span v-if="scope.row.Tstate=='1' && (scope.row.reportStatus=='待咨询主管审核' || scope.row.reportStatus=='危机主管审核驳回')" style="cursor: pointer;color: rgb(31, 52, 245);" @click="$refs.childdetail.Unabledetermine(scope.row,-1)">咨询主管初审</span>
                <span v-else-if="scope.row.Tstate=='1' && scope.row.reportStatus=='待危机主管复核' && scope.row.type != '咨询上报'" style="cursor: pointer;color: rgb(31, 52, 245);" @click="$refs.childdetail.Unabledetermine(scope.row,-2)">查看评估结果</span>
                <span v-else-if="scope.row.psychCentralSuggest!='' && scope.row.type != '咨询上报'" style="cursor: pointer;color: rgb(31, 52, 245);" @click="looksfun(scope.row.KeyNo, scope.row.reportStatus)">查看明细</span>
              </div>

              <div v-if="pdroleid(1059) && scope.row.type == '测评访谈'">
                <span v-if="scope.row.reportStatus == '风险监控员审核驳回' || scope.row.reportStatus == '危机主管审核驳回' || scope.row.reportStatus == '中心主任审核驳回'" style="cursor: pointer;color: rgb(31, 52, 245);" @click="Crisis_evaluation_view(scope.row.sourceNo, scope.row.userId,scope.row.KeyNo)">查看访谈表</span>
              </div>

              <div v-if="pdroleid(1059) && scope.row.reportStatus == '待咨询师评估'">
                <!-- <span style="cursor: pointer;color: rgb(31, 52, 245);" @click="evaluation(scope.row.KeyNo,scope.row.sourceNo,1)">咨询师评估</span> -->
                <span style="cursor: pointer;color: rgb(31, 52, 245);" @click="EditVisited(scope.row)">咨询师评估</span>
              </div>

              <div v-if="pdroleid(1059) && (scope.row.reportStatus == '待咨询师评估') ">
                <span style="cursor: pointer;color: rgb(31, 52, 245);" @click="looksfun(scope.row.KeyNo, scope.row.reportStatus,scope.row.userId)">查看重点台账</span>
              </div>
              <div v-if="pdroleid(1059) && scope.row.type == '日常危机'">
                <span v-if="scope.row.reportStatus == '风险监控员审核驳回' || scope.row.reportStatus == '咨询主管驳回' || scope.row.reportStatus == '危机主管审核驳回' || scope.row.reportStatus == '中心主任审核驳回'" style="cursor: pointer;color: rgb(31, 52, 245);" @click="$refs.childdetail.Unabledetermine(scope.row,0)">咨询师评估</span>
              </div>
              <!-- 1063是辅导员 -->
              <div v-if="(pdroleid(1063) || pdroleid(1089)) && (scope.row.type =='日常危机' || scope.row.type == '自主上报')">
                <span v-if="scope.row.reportStatus == '待建立重点台账'" style="cursor: pointer;color: rgb(31, 52, 245);" @click="Prefabricated_table(scope.row.KeyNo)">建立重点台账</span>
                <span v-else-if="scope.row.psychCentralSuggest != '' && scope.row.reportStatus == '风险监控员审核驳回'"  style="cursor: pointer;color: rgb(31, 52, 245);" @click="editfun(scope.row)">修改重点台账</span>
                <span v-else-if="scope.row.reportStatus == '无需干预' || scope.row.reportStatus == '待危机主管复核' || scope.row.reportStatus == '待中心主任审核' || scope.row.reportStatus == '待风险监控员初审' || scope.row.reportStatus == '无法确定' || scope.row.reportStatus == '风险监控员审核驳回' || scope.row.reportStatus == '中心主任审核驳回' || scope.row.reportStatus == '危机主管审核驳回'" style="cursor: pointer;color: rgb(31, 52, 245);" @click="Crisis_lookprefabrication(scope.row.KeyNo,scope.row.reportStatus,scope.row.userId)">查看重点台账</span>
                <span v-else-if="scope.row.reportStatus == '已上报'" style="cursor: pointer;color: rgb(31, 52, 245);" @click="Crisis_lookprefabrication(scope.row.KeyNo, scope.row.reportStatus)">查看台账</span>
                <span v-else-if="scope.row.reportStatus == '待上报' && scope.row.Tstate=='1'" style="cursor: pointer;color: rgb(31, 52, 245);" @click="LookViewRecordsfun(scope.row)">查看评估结果</span>
                <span v-if="scope.row.reportStatus == '待上报' " style="cursor: pointer;color: rgb(31, 52, 245);" @click="Crisis_lookprefabrication(scope.row.KeyNo, scope.row.reportStatus, scope.row.userId)">提交重点台账</span>
              </div>

              <!-- 1063是辅导员 -->
              <div v-if="(pdroleid(1063) || pdroleid(1089)) && scope.row.type == '咨询上报'">
                <span v-if="scope.row.reportStatus == '待建立重点台账'" style="cursor: pointer;color: rgb(31, 52, 245);" @click="Prefabricated_table(scope.row.KeyNo)">建立重点台账</span>
                <span  v-else-if="scope.row.reportStatus == '待上报' " style="cursor: pointer;color: rgb(31, 52, 245);" @click="Crisis_lookprefabrication(scope.row.KeyNo,scope.row.reportStatus,scope.row.userId)">提交重点台账</span>
                <span v-if="scope.row.psychCentralSuggest == ''"  style="cursor: pointer;color: rgb(31, 52, 245);" @click="ViewRecordsfun(scope.row)">查看上报结果</span>
                <span v-if="scope.row.psychCentralSuggest != '' && scope.row.reportStatus == '风险监控员审核驳回'"  style="cursor: pointer;color: rgb(31, 52, 245);" @click="editfun(scope.row)">修改重点台账</span>
                <span v-if="scope.row.psychCentralSuggest != '' && scope.row.reportStatus != '待上报'"  style="cursor: pointer;color: rgb(31, 52, 245);" @click="Crisis_lookprefabrication(scope.row.KeyNo,scope.row.reportStatus,scope.row.userId)">{{scope.row.reportStatus=='已上报'?'查看台账':'查看重点台账'}}</span>
              </div>
              
              <div v-else-if="pdroleid(1069) && (scope.row.type == '日常危机' || scope.row.type == '自主上报' || scope.row.type == '咨询上报')">
                <span v-if="scope.row.reportStatus == '无法确定'" style="cursor: pointer;color: rgb(31, 52, 245);" @click="audit2(scope.row.KeyNo, scope.row.type,scope.row.userId,scope.row.reportStatus)">待风险监控员初审</span>
                <span v-else-if="(scope.row.reportStatus == '待风险监控员初审' && scope.row.type == '咨询上报') && !scope.row.psychCentralSuggest" style="cursor: pointer;color: rgb(31, 52, 245);" @click="Visited(scope.row)">待风险监控员初审</span>
                <span v-else-if="(scope.row.reportStatus == '待风险监控员初审' && scope.row.type == '咨询上报') && scope.row.psychCentralSuggest" style="cursor: pointer;color: rgb(31, 52, 245);" @click="audit(scope.row.KeyNo, scope.row.type,scope.row.userId, scope.row.urgentStatus)">待风险监控员初审</span>
                <!-- <span v-else-if="(scope.row.reportStatus == '待风险监控员初审' || scope.row.reportStatus == '危机主管审核驳回') && scope.row.Tstate=='1'" style="cursor: pointer;color: rgb(31, 52, 245);" @click="$refs.childdetail.Unabledetermine(scope.row,-1)">风险监控员初审</span> -->
                <span v-else-if="scope.row.reportStatus == '待风险监控员初审' || scope.row.reportStatus == '危机主管审核驳回'" style="cursor: pointer;color: rgb(31, 52, 245);" @click="audit(scope.row.KeyNo, scope.row.type,scope.row.userId,scope.row.urgentStatus)">风险监控员初审</span>
                <span v-else-if="(scope.row.reportStatus == '待危机主管复核' || scope.row.reportStatus == '待中心主任审核' || scope.row.reportStatus == '风险监控员审核驳回' || scope.row.reportStatus == '中心主任审核驳回' ||  scope.row.reportStatus == '已上报') && scope.row.type == '咨询上报' && scope.row.psychCentralSuggest==''" style="cursor: pointer;color: rgb(31, 52, 245);" @click="ViewRecords(scope.row)">查看上报记录</span>
                <span v-else-if="scope.row.reportStatus == '待危机主管复核' || scope.row.reportStatus == '待中心主任审核' || scope.row.reportStatus == '待上报' || scope.row.reportStatus == '风险监控员审核驳回' || scope.row.reportStatus == '中心主任审核驳回'" style="cursor: pointer;color: rgb(31, 52, 245);" @click="Crisis_lookprefabrication(scope.row.KeyNo, scope.row.reportStatus,scope.row.userId)">查看重点台账</span>
                <span v-else-if="scope.row.reportStatus == '已上报'" style="cursor: pointer;color: rgb(31, 52, 245);" @click="Crisis_lookprefabrication(scope.row.KeyNo, scope.row.reportStatus)">查看台账</span>
                <!-- <span v-if="scope.row.reportStatus == '待危机主管复核' || scope.row.reportStatus == '待中心主任审核' || scope.row.reportStatus == '待上报' || scope.row.reportStatus == '风险监控员审核驳回' || scope.row.reportStatus == '中心主任审核驳回' || scope.row.reportStatus == '危机主管审核驳回' " style="cursor: pointer;color: rgb(31, 52, 245);" @click="Crisis_evaluation_view(scope.row.sourceNo, scope.row.userId,scope.row.KeyNo)">查看</span> -->
              </div>
              <!-- 1068危机主管 -->
              <div v-else-if="pdroleid(1068) && (scope.row.type == '日常危机' || scope.row.type == '自主上报' || scope.row.type == '咨询上报')">
                <span v-if="(scope.row.reportStatus == '待危机主管复核' || scope.row.reportStatus =='中心主任审核驳回' || scope.row.reportStatus =='风险监控员审核驳回') && scope.row.type == '咨询上报' && scope.row.psychCentralSuggest==''" style="cursor: pointer;color: rgb(31, 52, 245);" @click="Visited(scope.row)">危机主管复核</span>
              <span v-else-if="(scope.row.reportStatus == '待危机主管复核' && scope.row.type == '咨询上报') && !scope.row.psychCentralSuggest " @click="$refs.childdetail.Unabledetermine(scope.row,-1)" style="cursor: pointer;color: rgb(31, 52, 245);">危机主管复核</span>
                <span v-else-if="(scope.row.reportStatus == '待危机主管复核' && scope.row.type == '咨询上报') && scope.row.psychCentralSuggest "  @click="audit(scope.row.KeyNo, scope.row.type,scope.row.userId,scope.row.urgentStatus)" style="cursor: pointer;color: rgb(31, 52, 245);">危机主管复核</span>
                <span v-else-if="(scope.row.reportStatus == '待危机主管复核' && scope.row.type != '咨询上报')  "  @click="audit(scope.row.KeyNo, scope.row.type,scope.row.userId,scope.row.urgentStatus)" style="cursor: pointer;color: rgb(31, 52, 245);">危机主管复核</span>
                <span v-else-if="(scope.row.reportStatus == '待风险监控员初审' ||  scope.row.reportStatus == '待中心主任审核' || scope.row.reportStatus == '危机主管审核驳回' || scope.row.reportStatus == '无法确定' || scope.row.reportStatus == '风险监控员审核驳回' || scope.row.reportStatus == '中心主任审核驳回') && scope.row.type == '咨询上报' && scope.row.psychCentralSuggest==''" style="cursor: pointer;color: rgb(31, 52, 245);" @click="ViewRecords(scope.row)">查看上报记录</span>
              <span v-else-if="(scope.row.reportStatus == '待风险监控员初审' ||  scope.row.reportStatus == '待中心主任审核' || scope.row.reportStatus == '危机主管审核驳回' || scope.row.reportStatus == '无法确定' || scope.row.reportStatus == '风险监控员审核驳回' || scope.row.reportStatus == '中心主任审核驳回') && scope.row.Tstate=='1'" style="cursor: pointer;color: rgb(31, 52, 245);" @click="$refs.childdetail.Unabledetermine(scope.row,-2)">查看评估记录</span>
                <span v-else-if="scope.row.reportStatus == '中心主任审核驳回' &&  (scope.row.type == '日常危机' || scope.row.type == '自主上报' || scope.row.type == '咨询上报') && scope.row.psychCentralSuggest!='' " style="cursor: pointer;color: rgb(31, 52, 245);" @click="audit(scope.row.KeyNo, scope.row.type,scope.row.userId,scope.row.urgentStatus)">危机主管复核</span>
                <span v-else-if="scope.row.reportStatus == '待风险监控员初审' ||  scope.row.reportStatus == '待中心主任审核' || scope.row.reportStatus == '危机主管审核驳回' || scope.row.reportStatus == '无法确定' || scope.row.reportStatus == '风险监控员审核驳回' || scope.row.reportStatus == '待上报' || scope.row.reportStatus == '中心主任审核驳回'" style="cursor: pointer;color: rgb(31, 52, 245);" @click="Crisis_lookprefabrication(scope.row.KeyNo, scope.row.reportStatus,scope.row.userId)">查看重点台账</span>
                <span v-else-if="scope.row.reportStatus == '已上报'" style="cursor: pointer;color: rgb(31, 52, 245);" @click="Crisis_lookprefabrication(scope.row.KeyNo, scope.row.reportStatus)">查看台账</span>
                <span v-else-if="scope.row.psychCentralSuggest != ''" style="cursor: pointer;color: rgb(31, 52, 245);" @click="Crisis_lookprefabrication(scope.row.KeyNo, scope.row.reportStatus)">查看台账</span>
              </div>
              <!-- 1070中心主任 -->
              <div v-else-if="pdroleid(1070) && (scope.row.type == '日常危机' || scope.row.type == '自主上报' || scope.row.type == '咨询上报')">
                <span v-if="(scope.row.reportStatus == '待中心主任审核' && scope.row.type == '咨询上报') && !scope.row.psychCentralSuggest " style="cursor: pointer;color: rgb(31, 52, 245);" @click="Visited(scope.row)">中心主任审核</span>
                <span v-else-if="(scope.row.reportStatus == '待中心主任审核' && scope.row.type == '咨询上报') && scope.row.psychCentralSuggest " @click="audit(scope.row.KeyNo, scope.row.type,scope.row.userId,scope.row.urgentStatus)" style="cursor: pointer;color: rgb(31, 52, 245);">中心主任审核</span>
                <span v-else-if="(scope.row.reportStatus == '待中心主任审核' && scope.row.type != '咨询上报') " @click="audit(scope.row.KeyNo, scope.row.type,scope.row.userId,scope.row.urgentStatus)" style="cursor: pointer;color: rgb(31, 52, 245);">中心主任审核</span>
                <span v-else-if="(scope.row.reportStatus =='待风险监控员初审' || scope.row.reportStatus == '无法确定' || scope.row.reportStatus == '风险监控员审核驳回' || scope.row.reportStatus == '待危机主管复核' || scope.row.reportStatus == '危机主管审核驳回' || scope.row.reportStatus == '中心主任审核驳回') && scope.row.type == '咨询上报' && scope.row.psychCentralSuggest == ''" style="cursor: pointer;color: rgb(31, 52, 245); " @click="ViewRecords(scope.row)">查看上报记录</span>
                <span v-else-if="scope.row.reportStatus == '待风险监控员初审' || scope.row.reportStatus == '无法确定' || scope.row.reportStatus == '风险监控员审核驳回	' || scope.row.reportStatus == '待危机主管复核' || scope.row.reportStatus == '危机主管审核驳回' || scope.row.reportStatus == '中心主任审核驳回'" style="cursor: pointer;color: rgb(31, 52, 245); " @click="Crisis_lookprefabrication(scope.row.KeyNo, scope.row.reportStatus,scope.row.userId)">查看重点台账</span>
                <span v-else-if="scope.row.reportStatus == '待上报'" style="cursor: pointer;color: rgb(31, 52, 245);" @click="Crisis_lookprefabrication(scope.row.KeyNo, scope.row.reportStatus)">重点台账</span>
                <span v-else-if="scope.row.reportStatus == '已上报'" style="cursor: pointer;color: rgb(31, 52, 245);" @click="Crisis_lookprefabrication(scope.row.KeyNo, scope.row.reportStatus)">查看台账</span>
              </div>
              <!-- 1069风险监控员 -->
              <div v-else-if="pdroleid(1069) && scope.row.type == '测评访谈'">
                <span v-if="scope.row.reportStatus == '无法确定' || scope.row.reportStatus == '待风险监控员初审' || scope.row.reportStatus == '危机主管审核驳回'" style="cursor: pointer;color: rgb(31, 52, 245);" @click="Crisis_evaluation_audit(scope.row.sourceNo, scope.row.userId, scope.row.KeyNo, scope.row.type)">风险监控员初审</span>
                <!-- <span v-else-if="scope.row.reportStatus == '无法确定'" @click="Counselor_intervention(scope.row.KeyNo)" style="cursor: pointer;color: rgb(31, 52, 245);">安排咨询师介入</span> -->
                <span v-else-if="scope.row.reportStatus == '无需干预' || scope.row.reportStatus == '待危机主管复核' || scope.row.reportStatus == '待中心主任审核' || scope.row.reportStatus == '待上报'" style="cursor: pointer;color: rgb(31, 52, 245);" @click="Crisis_evaluation_view(scope.row.sourceNo, scope.row.userId,scope.row.KeyNo)">查看访谈表</span>
                <span v-if="scope.row.reportStatus == '已上报'" style="cursor: pointer;color: rgb(31, 52, 245);" @click="Crisis_lookprefabrication(scope.row.KeyNo, scope.row.reportStatus)">查看台账</span>
                <span v-if="scope.row.reportStatus == '已上报'" style="cursor: pointer;color: rgb(31, 52, 245);" @click="Crisis_evaluation_view(scope.row.sourceNo, scope.row.userId,scope.row.KeyNo)">查看访谈表</span>
                <span v-if="scope.row.reportStatus == '风险监控员审核驳回' || scope.row.reportStatus == '中心主任审核驳回'" style="cursor: pointer;color: rgb(31, 52, 245);" @click="Crisis_evaluation_view(scope.row.sourceNo, scope.row.userId,scope.row.KeyNo)">查看访谈表</span>
              </div>
              <!-- 1063辅导员 -->
              <div v-else-if="(pdroleid(1063) || pdroleid(1089)) && scope.row.type == '测评访谈'">
                <span v-if="scope.row.reportStatus == '待建立重点台账'" style="cursor: pointer;color: rgb(31, 52, 245);" @click="Prefabricated_table(scope.row.KeyNo)">建立重点台账</span>
                <span v-if="scope.row.reportStatus == '待建立重点台账'" style="cursor: pointer;color: rgb(31, 52, 245);" @click="Crisis_evaluation_view(scope.row.sourceNo, scope.row.userId,scope.row.KeyNo)">查看访谈表</span>
                <span v-if="scope.row.reportStatus == '待风险监控员初审' || scope.row.reportStatus == '无法确定' || scope.row.reportStatus == '无需干预' || scope.row.reportStatus == '待危机主管复核' || scope.row.reportStatus == '待中心主任审核' || scope.row.reportStatus == '已上报'"  style="cursor: pointer;color: rgb(31, 52, 245);" @click="Crisis_evaluation_view(scope.row.sourceNo, scope.row.userId, scope.row.KeyNo)">查看访谈表</span>

                <span v-if="scope.row.reportStatus == '待上报'"  style="cursor: pointer;color: rgb(31, 52, 245);" @click="Crisis_evaluation_account(scope.row.KeyNo, scope.row.reportStatus)">提交重点台账</span>
                
                <span v-if="scope.row.reportStatus == '待上报'"  style="cursor: pointer;color: rgb(31, 52, 245);" @click="Crisis_evaluation_view(scope.row.sourceNo, scope.row.userId,scope.row.KeyNo)">查看访谈表</span>

                <span v-if="scope.row.reportStatus == '已上报'" style="cursor: pointer;color: rgb(31, 52, 245);" @click="Crisis_lookprefabrication(scope.row.KeyNo, scope.row.reportStatus)">查看台账</span>

                <span v-if="scope.row.reportStatus == '风险监控员审核驳回' || scope.row.reportStatus == '危机主管审核驳回' || scope.row.reportStatus == '中心主任审核驳回'" style="cursor: pointer;color: rgb(31, 52, 245);" @click="Crisis_evaluation_view(scope.row.sourceNo, scope.row.userId,scope.row.KeyNo)">查看访谈表</span>
              </div>
              <!-- 1068危机主管 -->
              <div v-else-if="pdroleid(1068) && scope.row.type == '测评访谈'">
                <span v-if="scope.row.reportStatus == '待风险监控员初审' || scope.row.reportStatus == '无法确定' || scope.row.reportStatus == '无需干预' || scope.row.reportStatus == '待中心主任审核' || scope.row.reportStatus == '已上报'"  style="cursor: pointer;color: rgb(31, 52, 245);" @click="Crisis_evaluation_view(scope.row.sourceNo, scope.row.userId, scope.row.KeyNo)">查看访谈表</span>
                <span v-else-if="(scope.row.reportStatus == '待危机主管复核' || scope.row.reportStatus == '中心主任审核驳回')"  style="cursor: pointer;color: rgb(31, 52, 245);" @click="Crisis_evaluation_audit(scope.row.sourceNo, scope.row.userId, scope.row.KeyNo, scope.row.type)">危机主管复核</span>
              </div>
              <!-- 1070中心主任 -->
              <div v-else-if="pdroleid(1070) && scope.row.type == '测评访谈'">
                <span v-if="scope.row.reportStatus == '待风险监控员初审' || scope.row.reportStatus == '无法确定' || scope.row.reportStatus == '无需干预' || scope.row.reportStatus == '待危机主管复核' || scope.row.reportStatus == '待上报' || scope.row.reportStatus == '已上报'"  style="cursor: pointer;color: rgb(31, 52, 245);" @click="Crisis_evaluation_view(scope.row.sourceNo, scope.row.userId, scope.row.KeyNo,1)">查看访谈表</span>
                <span v-else-if="scope.row.reportStatus == '待中心主任审核'" @click="Crisis_evaluation_audit(scope.row.sourceNo, scope.row.userId, scope.row.KeyNo, scope.row.type)" style="cursor: pointer;color: rgb(31, 52, 245);">中心主任审核</span>
              </div>
              <!-- 危机上报弹窗 -->
              <div v-else-if="scope.row.type=='咨询上报' && scope.row.reportStatus=='未提交'">
                <span style="cursor: pointer;color: rgb(31, 52, 245);" @click="Visited((scope.row))">修改</span>
              </div>
              <div v-if="scope.row.type=='日常危机' && pdroleid(1079)">
                <span style="cursor: pointer;color: rgb(31, 52, 245);" @click="Crisis_lookprefabrication(scope.row.KeyNo, scope.row.reportStatus,scope.row.userId)">查看详情</span>
                <!-- <span v-if="scope.row.reportStatus == '待建立重点台账'" style="cursor: pointer;color: rgb(31, 52, 245);" @click="Prefabricated_table(scope.row.KeyNo)">建立重点台账</span>
                <span v-if="scope.row.reportStatus == '待上报'" style="cursor: pointer;color: rgb(31, 52, 245);" @click="Crisis_lookprefabrication(scope.row.KeyNo, scope.row.reportStatus, scope.row.userId)">重点台账</span>
                <span v-if="scope.row.reportStatus == '已上报'" style="cursor: pointer;color: rgb(31, 52, 245);" @click="Crisis_lookprefabrication(scope.row.KeyNo, scope.row.reportStatus)">查看台账</span>
                <span v-if="scope.row.reportStatus == '待辅导员审核' || scope.row.reportStatus == '待风险监控员初审' || scope.row.reportStatus == '无法确定' || scope.row.reportStatus == '辅导员审核驳回' || scope.row.reportStatus == '风险监控员审核驳回' || scope.row.reportStatus == '待危机主管复核' || scope.row.reportStatus == '危机主管审核驳回' || scope.row.reportStatus == '中心主任审核驳回'" style="cursor: pointer;color: rgb(31, 52, 245);" @click="Crisis_lookprefabrication(scope.row.KeyNo, scope.row.reportStatus,scope.row.userId)">查看重点台账</span> -->
              </div>
              <div v-if="scope.row.type=='日常危机' && (pdroleid(1063) || pdroleid(1089))">
                <span v-if="scope.row.reportStatus == '待辅导员审核'" style="cursor: pointer;color: rgb(31, 52, 245);" @click="audit(scope.row.KeyNo, scope.row.type,scope.row.userId)">辅导员审核</span>
              </div>
              <!-- <div v-if="scope.row.type=='日常危机' && (pdroleid(1063))">
                <span v-if="scope.row.reportStatus == '风险监控员审核驳回'" style="cursor: pointer;color: rgb(31, 52, 245);" @click="editfun(scope.row)">修改重点台账</span>
              </div> -->

              <div v-if="scope.row.type=='热线上报'">
                <span v-if="scope.row.reportStatus == '待热线管理员审核'"  style="cursor: pointer;color: rgb(31, 52, 245);" @click="xaxaii(scope.row)">热线管理员审核</span>                
                <span v-if="(scope.row.reportStatus == '热线管理员驳回' || scope.row.reportStatus == '待风险监控员初审' || scope.row.reportStatus == '风险监控员初审驳回' || scope.row.reportStatus == '待上报' || scope.row.reportStatus == '已上报'  || scope.row.reportStatus == '待危机主管复核' || scope.row.reportStatus == '待中心主任审核' || scope.row.reportStatus == '中心主任驳回') && pdroleid(1086)"  style="cursor: pointer;color: rgb(31, 52, 245);" @click="xaxaii(scope.row)">查看</span>
                <span v-if="scope.row.reportStatus == '待风险监控员初审' && pdroleid(1069)"  style="cursor: pointer;color: rgb(31, 52, 245);" @click="xaxaii(scope.row)">风险监控员初审</span>
                <span v-if="(scope.row.reportStatus == '待危机主管复核' || scope.row.reportStatus == '中心主任审核驳回') && pdroleid(1068)"  style="cursor: pointer;color: rgb(31, 52, 245);" @click="xaxaii(scope.row)">危机主管复核</span>
                <span v-if="scope.row.reportStatus == '待中心主任审核' && pdroleid(1070)"  style="cursor: pointer;color: rgb(31, 52, 245);" @click="xaxaii(scope.row)">待中心主任审核</span>
                <span  v-if="scope.row.reportStatus == '待上报' && (pdroleid(1063) || pdroleid(1089))" style="cursor: pointer;color: rgb(31, 52, 245);" @click="Crisis_evaluation_account(scope.row.KeyNo, scope.row.reportStatus)">提交重点台账</span>
              </div>
              <!-- 风险监控员和危机主管办理 -->
              <div v-if="scope.row.reportStatus == '待上报'&&(pdroleid(1069)||pdroleid(1068))">
                <span v-if="scope.row.FeedBackState == 4&&pdroleid(1069)" style="cursor: pointer;color: rgb(31, 52, 245);" @click="audit2(scope.row.KeyNo, scope.row.type,scope.row.userId,scope.row.reportStatus)">风险监控员办理</span>
                <span v-if="scope.row.FeedBackState == 3&&pdroleid(1068)" style="cursor: pointer;color: rgb(31, 52, 245);" @click="audit2(scope.row.KeyNo, scope.row.type,scope.row.userId,scope.row.reportStatus)">危机主管办理</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      <el-pagination style="margin-top: 20px;text-align: right" @current-change="handleCurrentChange" :current-page.sync="pageIndexs" :page-size="10" layout="total, prev, pager, next" :total="Count" v-if="Count > 0"></el-pagination>
      </div>
    </el-container>
    <!--危机个案上报-->
    <Crisiscases ref="childdetail"></Crisiscases>
  </div>
</template>
<script>
import Crisiscases from './../Consultant/Crisiscases.vue';
export default {
  data() {
    return {
      StartTime: '',
      EndTime: '',
      gradedata:[],
      // time: this.Global.querycensus(6),
      DeptIDcz: '',
      RoleID: '',
      jiaose:'辅导员',
      DeptID: '',
      optionsnew: [],
      Count: 0,
      pageIndexs: 1,
      ruleForm: {
        Name:"",//综合查询
        DeptID:"",//培训单位
        EntryDate:"",//年级
        Degree:"",//学位
        Type:"",//上报类型
        ReportStatus:"",//上报状态
        pageIndex:1,
        pageSize:'10',
        UrgentStatus:'',
        FeedBackState:'',//办理状态
        ts:'',
        order:'',//asc是升序，desc是降序
      },
      form: {DeptName:"",RealName:"",Status:"",UserID:"",entity:"管理员",pageIndex:1,pageSize:"10"},
      tableData: [],
      loading:false,
      keyLedgerOverallStatistics:'',
    }
  },
  methods: {
    editfun(row){
      this.$router.push({
        path: '/Crisis/Crisis_editprefabrication',
        query: { KeyNo: row.KeyNo, reportStatus : row.reportStatus, userId: row.userId },
      })
    },
    // 办理状态转文字（FeedBackState）
    getFeedBackStateText(val) {
      // 默认或空：待复核
      if (val === null || val === undefined || val === '' || val === 0 || val === '0') {
        return '待复核';
      }
      switch (val.toString()) {
        case '1': return '已驳回';
        case '2': return '待复核';
        case '3': return '待危机主管办理';
        case '4': return '待风险监控员办理';
        case '5': return '已办理';
        default:  return '待复核';
      }
    },
    // 危机主管办理：进入办理明细页面维护办理内容
    crisisAdminHandle(row) {
      this.$router.push({
        path: '/Crisis/Crisis_lookreport',
        query: { KeyNo: row.KeyNo, type: 2 }, // type=2 表示办理
      });
    },
    evaluation(TalkNo, SourceNo,type) {
      this.$router.push({
        path: '/Crisis/Crisis_Memcon_evaluation',
        query: {TalkNo:TalkNo,SourceNo:SourceNo,type:type},
      });
    },
    looks(KeyNo,type) {
      this.$router.push({
        path: '/Crisis/Crisis_lookreport',
        query: { KeyNo: KeyNo, type: type},
      })
    },
    Counselor_intervention(KeyNo){
      this.$router.push({
        path: '/Crisis/Crisis_Counselor_intervention',
        query: { KeyNo: KeyNo},
      })
    },
    Crisis_evaluation_account(KeyNo, reportStatus) {//心理测评危机台账
      this.$router.push({
        path: '/Crisis/Crisis_evaluation_account',
        query: { KeyNo: KeyNo, reportStatus: reportStatus },
      })
    },
    Crisis_evaluation_view(PublishID, UserID,KeyNo) {//查看访谈表
      this.$router.push({
        path: '/Crisis/Crisis_evaluation_view',
        query: { PublishID: PublishID, UserID: UserID , KeyNo : KeyNo},
      })
    },
    Crisis_evaluation_audit(PublishID, UserID, KeyNo, type) {//日常危机审批
      this.$router.push({
        path: '/Crisis/Crisis_evaluation_audit',
        query: { PublishID: PublishID, UserID: UserID , KeyNo : KeyNo , type : type },
      })
    },
    audit(KeyNo, type,userId,reportStatus) {//跳转审核页面
      this.$router.push({
        path: '/Crisis/Crisis_Committee_early',
        query: { KeyNo: KeyNo, type:type, userId:userId,reportStatus:reportStatus},
      })
    },
    audit2(KeyNo, type,userId,reportStatus) {//跳转审核页面
      this.$router.push({
        path: '/Crisis/Crisis_Committee_early',
        query: { KeyNo: KeyNo, type:type, userId:userId,reportStatus:reportStatus},
      })
    },
    
    Prefabricated_table(KeyNo) {//填写预制表
      this.$router.push({
        path: '/Crisis/Crisis_addmajor_event',
        query: { KeyNo: KeyNo },
      })
    },
    Crisis_lookprefabrication(KeyNo, reportStatus, userId) {
      this.$router.push({
        path: '/Crisis/Crisis_lookprefabrication',
        query: { KeyNo: KeyNo, reportStatus : reportStatus, userId: userId },
      })
    },
    looksfun(KeyNo, reportStatus, userId){
      this.$router.push({
        path: '/Crisis/Crisis_detail',
        query: { KeyNo: KeyNo, reportStatus : reportStatus, userId: userId },
      })
    },
    lookreport(KeyNo) {
      this.$router.push({
        path: '/Crisis/Crisis_lookreport',
        query: { KeyNo: KeyNo },
      })
    },
    Selected_to_shut_dow(dt,a) {
      const cascader = this.$refs.wcascader;
      const node = cascader.panel.getNodeByValue(dt);
      this.ruleForm.ts = node.getText(cascader.showAllLevels, cascader.separator)
      this.DeptID = dt[dt.length - 1];
      this.$refs.wcascader.dropDownVisible = false;
    },
    GetNodeByDeptID(ID, NodeList) {
      let obj = null;
      for (let i = 0; i < NodeList.length; i++) {
        if (NodeList[i].DeptID == ID) {
          obj = NodeList[i];
          break;
        } else if (NodeList[i].fuzi && NodeList[i].children.length > 0 && NodeList[i].children[0].DeptID != '-1') {
          this.GetNodeByDeptID(ID, NodeList[i].children);
        }
      }
      return obj;
    },
    bumen(dt) {
      let obj = this.optionsnew[0];
      for (let i = 0; i < this.optionsnew.length; i++) {
        if (this.optionsnew[i].DeptID == dt[dt.length - 1]) {
          obj = this.optionsnew[i];
          break;
        } else if (this.optionsnew[i].fuzi && this.optionsnew[i].children.length > 0 && this.optionsnew[i].children[0].DeptID != '-1') {
          obj = this.GetNodeByDeptID(
            dt[dt.length - 1],
            this.optionsnew[i].children
          );
        }
      }
      let _this = this;
      if (obj.fuzi && obj.children.length > 0 && obj.children[0].DeptID == '-1') {
        obj.children = [{ label: '数据加载中...'}];
        this.$Http_Post('/DepartMent/GetDeprtMentByNode',{DeptID:dt[dt.length - 1],content:''}).then((res) => {
          if (res.Code == 200 || res.Code == 0 && res.Data) {
            obj.children = res.Data;
          }
        });
      }
    },
    gourl(val) {
      let routeData = this.$router.resolve({
        path:'/visitors/ReportShow',
        query: { PaperResultID:a},
      })
      window.open(routeData.href,'_blank');
    },
    ceshigorl() {
      this.$router.push("/Crisis/Crisis_intervention?id=111");
    },

    changeReporttime({ column,prop, order }){
      if(prop == 'reportTime'){
        if(order == 'ascending'){//升序
          this.ruleForm.order = 'RecordTime asc';
        }else if(order == 'descending'){//降序
          this.ruleForm.order = 'RecordTime desc';
        }else{
          this.ruleForm.order = '';
        }
      }else if(prop == 'urgentStatus'){
        if(order == 'ascending'){//升序
          this.ruleForm.order = 'FirstCrisis asc';
        }else if(order == 'descending'){//降序
          this.ruleForm.order = 'FirstCrisis desc';
        }else{
          this.ruleForm.order = '';
        }
      }
      this.Init(this.ruleForm);
    },

    Init(form) {//列表
      this.loading = true;
      this.$Http_Post('DistressPrediction/GetUrgent',{
        pageSize:'10',
        pageIndex:this.ruleForm.pageIndex,
        Name:this.ruleForm.Name,
        DeptID:this.DeptID,
        EntryDate:this.ruleForm.EntryDate,
        Degree:this.ruleForm.Degree,
        Type:this.ruleForm.Type,
        Status:this.ruleForm.ReportStatus, 
        RoleID:this.RoleID,
        UrgentStatus:this.ruleForm.UrgentStatus,
        feedBackState:this.ruleForm.FeedBackState,
        StartTime: this.StartTime,
        EndTime: this.EndTime,
        order:this.ruleForm.order,
      }).then((res) => {
        this.loading = false;
        if (res.Code == 200 || res.Code == 0) {
          this.tableData = res.Data.tbl;
          this.keyLedgerOverallStatistics = res.Data.vo
          this.Count = res.Counts;
        }else{
          this.$message.error(res.Message);
        }
      });
    },
    handleCurrentChange(val) {//分页点击
      this.ruleForm.pageIndex = val;
      localStorage.setItem("Crisis_upreport_pageIndex",val)
      this.Init(this.form);
    },
    Go_Review_key(val) {
      sessionStorage.setItem('Crisis_upreport_type',val.row.UrgentStatus);
      this.$router.push({
        path: '../Crisis/Review_key',
        query: {id:val.row.userid,SourceNo:val.row.SourceNo,TableCngResultID:val.row.TableCngResultID},
      })
    },
    xaxaii(row){
      this.$router.push({
        path: '../Crisis/Hot_wire',
        query: {sourceNo:row.sourceNo,type:row.reportStatus,KeyNo:row.KeyNo},
      })
    },
    addfun(){
      this.$router.push({
        path: '../Crisis/Daily_New_account',
      })
    },
    ClickHotwire(){
      this.$router.push({
        path: '../Crisis/Hot_wire',
      })
    },
    resetForm() {
      localStorage.removeItem("Crisis_upreport_pageIndex");
      localStorage.removeItem("Crisis_upreport");
      localStorage.removeItem("Crisis_upreport_DeptID");
      this.pageIndexs = 1;
      this.ruleForm.Name = '';
      this.StartTime = '';
      this.EndTime = '';
      this.ruleForm.DeptID = this.DeptIDcz;
      this.DeptID = this.DeptIDcz;
      this.ruleForm.EntryDate = '';
      this.ruleForm.Degree = '';
      this.ruleForm.ReportType = '';
      this.ruleForm.ReportState = '';
      this.ruleForm.pageIndex = 1;
      this.ruleForm.Type = '';
      this.ruleForm.ReportStatus = '';
      this.ruleForm.UrgentStatus = '';
      this.ruleForm.FeedBackState = '';
      this.ruleForm.order = '';
      this.Init();
    },
    onSelect() {
      // 判断 DeptID 是否为空：可能是数组、字符串、null、undefined、对象
      let isEmpty = false;
      if (!this.DeptID) {
        isEmpty = true;
      } else if (Array.isArray(this.DeptID)) {
        isEmpty = this.DeptID.length === 0;
      } else if (typeof this.DeptID === 'string') {
        isEmpty = this.DeptID.trim() === '';
      } else if (typeof this.DeptID === 'object') {
        isEmpty = Object.keys(this.DeptID).length === 0;
      }
      
      if (isEmpty) {
        this.$message.warning('请选择部门');
        return;
      }
      localStorage.setItem("Crisis_upreport_pageIndex",1);
      localStorage.setItem('Crisis_upreport',JSON.stringify(this.ruleForm));
      localStorage.setItem('Crisis_upreport_DeptID',JSON.stringify(this.DeptID));
      this.ruleForm.pageIndex = 1;
      this.pageIndexs = 1;
      this.Init();
    },
    pdroleid(id) {
      var RoleID = sessionStorage.getItem('RoleID');
      if (RoleID.indexOf(id) !== -1) {
        return true;
      } else {
        return false;
      }
    },
    jump(val) {
      this.$router.push({path:"/Crisis/Crisis_evaluation_view",query:{id:val}});
    },
    jum2p(val) {
      this.$router.push({path:"/Crisis/Hotline_Crisis_Synchronization",query:{id:val}});
    },
    Visited(e) {
      this.$refs.childdetail.CrisisreporDetail(e,-1);
    },
    ViewRecords(e){
      this.$refs.childdetail.CrisisreporDetail(e,-2);
    },
    Viewreject(e){
      this.$refs.childdetail.Crisisreporreject(e,-2);
    },
    ViewRecordsfun(e){
      this.$router.push({path:"/Crisis/Crisis_details",query:{KeyNo:e.KeyNo,sourceNo:e.sourceNo}});
    },
    LookViewRecordsfun(e){
      this.$router.push({path:"/Crisis/Crisis_details",query:{KeyNo:e.KeyNo}});
    },
    // 可编辑危机个案上报
    EditVisited(e){
      this.$refs.childdetail.Consultantevaluation(e,0);
    }
  },
  mounted() {
    const now = new Date();
    const year = now.getFullYear();
    const month = (now.getMonth() + 1).toString().padStart(2, '0');
    const day = now.getDate();
    this.EndTime = year + '-'+ month + '-' + day
    this.StartTime = year-1 + '-'+ month + '-' + day
    this.RoleID = sessionStorage.getItem('RoleID');
    this.$Http_Post('User/GetDictionaryList',{DicTypCode:1}).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.gradedata = res.Data;
      }
    })
    this.$Http_Post('/DepartMent/GetDeprtMentByNode', {DeptID:'',content:''}).then((res) => {
      if (res.Data) {
        this.optionsnew = res.Data;
        this.DeptIDcz = this.DeptID = res.Data[0].DeptID;
        if(localStorage.getItem("Crisis_upreport_DeptID")){
          this.DeptID = JSON.parse(localStorage.getItem("Crisis_upreport_DeptID"));
        }else{
          this.DeptID = res.Data[0].DeptID;
        }
        this.ruleForm.DeptID = res.Data[0].DeptID;
        this.chongzhiDeptID = res.Data[0].DeptID;
        this.Init(this.form);
      }
    });
    if(localStorage.getItem("Crisis_upreport")){
      this.ruleForm = {
        Name: JSON.parse(localStorage.getItem("Crisis_upreport")).Name,//综合查询
        DeptID:"",//培训单位
        EntryDate:JSON.parse(localStorage.getItem("Crisis_upreport")).EntryDate,//年级
        Degree:JSON.parse(localStorage.getItem("Crisis_upreport")).Degree,//学位
        Type:JSON.parse(localStorage.getItem("Crisis_upreport")).Type,//上报类型
        ReportStatus:JSON.parse(localStorage.getItem("Crisis_upreport")).ReportStatus,//上报状态
        pageIndex:JSON.parse(localStorage.getItem("Crisis_upreport_pageIndex")),
        pageSize:'10',
        UrgentStatus:JSON.parse(localStorage.getItem("Crisis_upreport")).UrgentStatus,
        FeedBackState:JSON.parse(localStorage.getItem("Crisis_upreport")).FeedBackState,
        ts:JSON.parse(localStorage.getItem("Crisis_upreport")).ts,
      }
      this.pageIndexs = JSON.parse(localStorage.getItem("Crisis_upreport_pageIndex"));
    }
  },
  components:{
    Crisiscases
  }
}
</script>
<style>

.Crisis_upreport button {
  margin-bottom: 20px;
}

.Crisis_upreport .cell span {
  margin-left: 10px;
  text-align: center;
}

.el-table--enable-row-transition .el-table__body td {
  text-align: center;
}
</style>